export default "__VITE_ASSET__4uxnGdg4__"